import 'bootstrap/dist/css/bootstrap.min.css'
import { breakpoints } from 'style'
import { createGlobalStyle } from 'styled-components'
import { colors } from './index'

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    height: 100%;
    font-family: 'Mabry Pro';
  }
  .App {
    height: 100vh;
  }
  .cursor {
    cursor: pointer;
  }

  .cursor-grab {
    cursor: grab;
  }

  h1 {
    font-size: 60px;
    font-family: 'Mabry Pro Medium';
    @media (max-width: ${breakpoints.sm}px) {
      font-size: 32px;
    }
  }
  h2 {
    font-size: 44px;
    font-family: 'Mabry Pro Medium';
    @media (max-width: ${breakpoints.sm}px) {
      font-size: 32px;
    }
  }
  h3 {
    font-size: 24px;
    font-family: 'Mabry Pro';
  }
  h4 {
    font-size: 18px;
    line-height: 28px;
    font-family: 'Mabry Pro';
  }
  h5 {
    font-family: 'Mabry Pro';
  }
  h6 {
    font-family: 'Mabry Pro';
  }
  a {
    /* text-decoration: underline; */
    color: #212529;
  }
  .container {
    @media (min-width: 1484px) {
      min-width: 1484px;
    }
  }
  button, .button {
    font-size: 18px;
    font-weight: 700;
    border: none;
    transition: all .45s;
  }
    .btn-dash {
    height: 25px;
    border-radius: 5px;
    font-size: 15px;
    padding: 0 16px;
  }
  .btn-blue {
    background-color: ${colors.blueDark};
    border: 2px solid ${colors.blueDark};
  }
  .btn-blue:hover,
  .btn-blue:active,
  .btn-blue:focus-visible,
  .btn-blue:focus {
    background-color: ${colors.white};
    color: ${colors.blueDark};
    border: 2px solid ${colors.blueDark};
  }

  .btn-blue.disabled, .btn-blue:disabled {
    background-color: ${colors.blueDark};
    border: 2px solid ${colors.blueDark};
    color: ${colors.white};
  }

  .btn-white {
    background-color: ${colors.white};
    color: ${colors.blueDark};
    border: 2px solid ${colors.blueDark};
  }
  .btn-white:hover,
  .btn-white:active,
  .btn-white:focus-visible,
  .btn-white:focus {
    background-color: ${colors.blueDark};
    color: ${colors.white};
    border: 2px solid ${colors.blueDark};
  }
  .btn-redLight {
    height: 25px;
    border-radius: 5px;
    color: white;
    font-size: 15px;
    background-color: #E01414;
    padding: 0 16px;
    &:hover {
      background-color: #F15C5C;
    }
    &:disabled {
      background-color: #F15C5C;
      cursor: not-allowed;
    }
  }
  .btn-red {
    height: 25px;
    border-radius: 5px;
    color: white;
    font-size: 15px;
    background-color: #DF1919;
    padding: 0 16px;
    &:hover {
      background-color: #E08218;
    }
    &:disabled {
      background-color: #E08218;
      cursor: not-allowed;
    }
  }
  .btn-darkgreen {
    height: 25px;
    border-radius: 5px;
    color: white;
    font-size: 15px;
    background-color: #0B4141;
    padding: 0 16px;
    &:hover {
      background-color: #0F6468;
    }
    &:disabled {
      background-color: #0F6468;
      cursor: not-allowed;
    }
  }
  .btn-orange {
    height: 25px;
    border-radius: 5px;
    color: white;
    font-size: 15px;
    background-color: #CE4E05;
    padding: 0 16px;
    &:hover {
      background-color: #E08218;
    }
    &:disabled {
      background-color: #E08218;
      cursor: not-allowed;
    }
  }
  .bg-gray {
    background: rgba(0, 0, 0, 0.13);
  }
  .invalid-feedback {
    color: ${colors.blueDark};
  }
  .uppercase {
    text-transform: uppercase;
  }

  .error-message {
    color: ${colors.red};
  }

  .p20 {
    padding: 20px;
  }

  .p1020 {
    padding: 10px 20px;
  }

  .p20201040 {
    padding: 20px 20px 10px 40px;
  }

  .p2010 {
    padding: 10px 20px;
  }

  .pl40 {
    padding-left: 40px;
  }

  .pl20 {
    padding-left: 20px;
  }

  .ml-rem {
    margin-left: 1rem;
  }

  .mb2rem {
    margin-bottom: 2rem !important;
  }
  .mt1rem {
    margin-top: 1rem !important;
  }

  .bb-line {
    border-bottom: 1px solid #f2f2f2;
  }

  .section-container {
    background-color: ${colors.white};
    border-radius: 15px;
    padding: 1rem 2rem;
    margin-bottom: 1rem;
  }

  .btn-anec-green {
    background-color: rgb(78, 158, 105) !important;
    border-color: rgb(78, 158, 105) !important;
    color: white !important;
  }

  .btn-anec-grey {
    background-color: rgb(76, 76, 76) !important;
    border-color: rgb(76, 76, 76) !important;
    color: white !important;
  }

  .hide {
    display: none !important;
  }
`

export default GlobalStyle
